export function formatNumber(num) {
    const isNegative = num < 0;
    const absoluteNum = Math.abs(num);

    let formattedNumber = '';

    if (absoluteNum >= 1e12) {
        formattedNumber = (absoluteNum / 1e12).toFixed(1) + 'T'; // Trillions
    } else if (absoluteNum >= 1e9) {
        formattedNumber = (absoluteNum / 1e9).toFixed(1) + 'B'; // Billions
    } else if (absoluteNum >= 1e6) {
        formattedNumber = (absoluteNum / 1e6).toFixed(1) + 'M'; // Millions
    } else if (absoluteNum >= 1e3) {
        formattedNumber = (absoluteNum / 1e3).toFixed(1) + 'k'; // Thousands
    } else {
        formattedNumber = absoluteNum.toString(); // Less than 1000, return as is
    }

    return isNegative ? `-${formattedNumber}` : formattedNumber;
}
